import { Box } from "@chakra-ui/react";
import ThemeToggle from "./ThemeToggle";

const AuthNav = () => {
  return (
    <Box p="30px">
      <ThemeToggle ml="auto" />
    </Box>
  );
};

export default AuthNav;
